import { z } from 'zod'

import { PersonDisplay } from '@/models/features/display-column.models'

export const AnnouncementRecipientStatusEnum = z.enum(['sent', 'delivered', 'opened', 'clicked'])

export type AnnouncementRecipientStatus = z.infer<typeof AnnouncementRecipientStatusEnum>

export interface AnnouncementRecipientModel {
  // Note: the BE's per-column person details - only the fields enabled in its settings (EL-15064)
  residentDisplay?: PersonDisplay
  id: number
  residentId: number
  residentName: string
  unitNumber: string
  avatar: string
  email?: string
  firstName: string
  lastName: string
  phone?: string | null
  buildingNumber?: string | null
  street?: string | null
  status?: AnnouncementRecipientStatus
  updatedAt?: number
}
